import React, { useContext } from 'react'

import { MarketplaceCardContext } from './context'

interface TitleProps {
  children: React.ReactNode
}

export function Title ({ children }: TitleProps) {
  const { href, isClickable, titleId, titleRef, target } = useContext(
    MarketplaceCardContext
  )

  const className = 'appearance-none text-left heading-sm text-gray-800 hover:text-gray-800 outline-none'

  if (isClickable && !!href) {
    return (
      <a
        className={className}
        href={href}
        id={titleId}
        ref={titleRef}
        target={target}
      >
        {children}
      </a>
    )
  }

  if (isClickable && !href) {
    return (
      <button className={className} id={titleId}>
        {children}
      </button>
    )
  }

  return (
    <div className={className} id={titleId}>{children}</div>
  )
}

Title.displayName = 'MarketplaceCard.Title'
